$(document).ready(function () {
    console.log("entrou na função");
    $("body").append(style);

    console.log("entrou na função");
    slider = $(".slideShow2");
    slider.append(`<div class="sbtn sNext"></div>`);
    slider.append(`<div class="sbtn sPrev"></div>`);
    slider.append(`<div class="altInformation"></div>`);
    slider.children("p").remove();
    qtd = (slider.children().length - 3);
    now = 0;
    slider.children(".altInformation").empty().append(slider.children().eq(0).attr("alt"));
    slider.children().eq(0).addClass("show");
})


$(document).on('click', '.sNext', function(){
    if(now + 1 >= qtd){
        now = 0;
        toSlider(now);
    }else{
        now++
        toSlider(now);
    }
});

$(document).on('click', '.sPrev', function(){
    if((now - 1) < 0){
        now = (qtd -1);
        toSlider(now);
    }else{
        now--
        toSlider(now);
    }
});

toSlider = (to) =>{
    slider.children().removeClass("show");
    slider.children(".altInformation").empty().append(slider.children().eq(to).attr("alt"));
    slider.children().eq(to).addClass("show");
}


style = `
        <style>
            .slideShow2 img{
                display: none;
                width: 100%;
padding:30px 40px 30px 30px;

            }

            .altInformation{
                width: 100%;
                bottom: 0px;
                color: gray;
background-color: white;
                padding: 15px 30px;
                font-size: 18px;
                font-family: "Plantin Light";
                font-style: italic;
                text-align: left;
            }

            .slideShow2 img.show{
                display: block
            }

            .slideShow2{
                position: relative
            }

            .slideShow2 .sbtn{
                position: absolute;
                cursor: pointer;
                color: white;
                font-size: 20px;
                font-family: "Akurrat Light"!important;
                padding: 6px 15px;
                top: 50%;
                transform: translateY(-50%);
width:20px;
height:40px;
            
            }

            .sNext{
display:none;
                right: 0px;
background-image: url(https://cdn.shopify.com/s/files/1/0367/1048/2051/files/next.png);
background-repeat:no-repeat;
            }

            .sPrev{
display:none;
                left: 0px;
background-image: url(https://cdn.shopify.com/s/files/1/0367/1048/2051/files/previous.png);
background-repeat:no-repeat;
            }

        <style>
    `

